<script>
import { mapActions } from "vuex";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    contractId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    formData: {
      id: null,
      promotion: null,
      isPercent: false,
    },

    model: true,
  }),

  created() {
    if (this.data.id) {
      this.formData = JSON.parse(JSON.stringify(this.data));
      //this.formData.paymentDate = this.$date(this.formData.paymentDate);
      //this.formData.paymentValue = this.$date(this.formData.endDate);
    }
  },

  methods: {
    ...mapActions("admin-contract2022", ["SAVE_APPLICATION_PROMOTION"]),

    onSend() {
      if (this.$refs.form.validate()) {
        const params = { ...this.formData, contractId: this.$route.params.id };

        this.SAVE_APPLICATION_PROMOTION(params).then((status) => {
          if (status != null) {
            window.location.reload();
          }
        });
      }
    },
  },
};
</script>

<template>
  <v-form
    :readonly="isReadonly"
    @submit.prevent="() => false"
    ref="form"
    lazy-validation
  >
    <div class="section-header">{{ $t("Promition miqdori") }}</div>
    <div class="py-13 px-6">
      <div class="row">
        <div class="cols-12 col-md-5">
          <div>
            <!--            <admin-app-show-detail :title="$t('Promition miqdori')" />-->
            <!--            <admin-app-show-detail
              class="pt-4"
              :title="$t('Kontract summasi')"
              money :text="application.totalSumma"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Tolangan summasi')"
              money :text="application.totalPaidSumma"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Qoldiq')"
              money :text="application.totalOstatok"
            />-->
            <div class="form-label">
              {{ $t("Attention promotion") }} <span v-text="'*'" />
            </div>
            <v-checkbox
              :label="$t('promtion foizdami')"
              v-model="formData.isPercent"
            />

            <v-text-field
              autocomplete="off"
              @blur="onChangeApp"
              v-model="formData.promotion"
              dense
              outlined
              required
              :rules="[$rules.required]"
              style="text-align: left"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div align="center" class="col-12">
        <v-btn @click="onSend" color="accent">
          {{ $t("Save") }}
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<style lang="scss" scoped>
.section-header {
  background: rgb(0, 150, 219);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25em;
  color: white;
  padding: 5px;
}

.form-label {
  font-weight: 500;
  margin-bottom: 8px;

  span {
    padding-left: 2px;
    color: red;
  }
}

.review-msg {
  position: absolute;
  top: -26px;
}
</style>
